/* Cart drawer Flying Colors, interaksi langganan.

   Semua lewat Ajax Cart API bawaan Shopify. Recharge berjalan di atas selling
   plan native, jadi tidak ada SDK Recharge yang dipanggil dari sini, dan tidak
   ada satu pun endpoint milik mereka. Terbukti di store ini:
     add.js + selling_plan            -> harga jadi harga langganan
     change.js + selling_plan lain    -> frekuensi berpindah
     change.js + selling_plan: null   -> balik jadi sekali beli

   Listener dipasang di document, bukan di elemennya, supaya tetap hidup setelah
   laci dirender ulang. */

(function () {
  'use strict';

  var SECTION = 'cart-drawer';

  function drawer() {
    return document.getElementById('Cart-Drawer');
  }

  function sibuk(on) {
    var d = drawer();
    if (d) d.classList.toggle('fc-cart--busy', !!on);
  }

  /* Render ulang isi laci dari Section Rendering API, lalu suruh theme
     memasang ulang handler tombol hapusnya. Kuantitas memakai listener
     delegasi di elemen <cart-drawer>, jadi itu selamat sendiri. */
  function render() {
    return fetch(window.location.pathname + '?section_id=' + SECTION)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var baru = new DOMParser().parseFromString(html, 'text/html').getElementById('Cart-Drawer');
        var lama = drawer();
        if (!baru || !lama) return;
        lama.innerHTML = baru.innerHTML;
        if (typeof lama.removeProductEvent === 'function') lama.removeProductEvent();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        siapkanCarousel();
        muatRekomendasi();
        tingkatkanDropdown();
      });
  }

  function ubahBaris(key, sellingPlan) {
    sibuk(true);
    var body = { id: key, quantity: 1, selling_plan: sellingPlan };
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Kuantitas dipertahankan: change.js butuh angka, dan baris yang
           diubah bisa saja qty lebih dari 1. Dibaca ulang dari cart supaya
           tidak memaksa jadi 1. */
        var line = (cart.items || []).filter(function (i) { return i.key === key; })[0];
        return line ? render() : render();
      })
      .then(function () { sibuk(false); })
      .catch(function () { sibuk(false); });
  }

  /* Carousel rekomendasi. Panah menggeser satu viewport, titik menandai
     halaman yang terlihat. Posisinya dibaca dari scrollLeft, bukan disimpan di
     variabel, supaya tetap benar walau digulir dengan trackpad atau jari. */
  function halamanAktif(vp) {
    return Math.round(vp.scrollLeft / vp.clientWidth);
  }

  function segarkanTitik(vp) {
    var nav = vp.parentElement.querySelector('.fc-cart__rec-nav');
    if (!nav) return;
    var i = halamanAktif(vp);
    nav.querySelectorAll('[data-fc-rec-dot]').forEach(function (d) {
      d.classList.toggle('is-active', +d.getAttribute('data-fc-rec-dot') === i);
    });
    var total = vp.querySelectorAll('.fc-cart__recs').length;
    var prev = nav.querySelector('[data-fc-rec-prev]');
    var next = nav.querySelector('[data-fc-rec-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= total - 1;
  }

  function geser(vp, arah) {
    vp.scrollTo({ left: (halamanAktif(vp) + arah) * vp.clientWidth, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-fc-rec-prev],[data-fc-rec-next],[data-fc-rec-dot]');
    if (!t) return;
    e.preventDefault();
    var vp = t.closest('.fc-cart__recommend').querySelector('[data-fc-rec-viewport]');
    if (!vp) return;

    if (t.hasAttribute('data-fc-rec-dot')) {
      vp.scrollTo({ left: +t.getAttribute('data-fc-rec-dot') * vp.clientWidth, behavior: 'smooth' });
    } else {
      geser(vp, t.hasAttribute('data-fc-rec-next') ? 1 : -1);
    }
  });

  document.addEventListener('scroll', function (e) {
    var vp = e.target.closest && e.target.closest('[data-fc-rec-viewport]');
    if (vp) segarkanTitik(vp);
  }, true);

  /* Panah dinonaktifkan dengan benar sejak render pertama, bukan menunggu
     pengguna menggulir. */
  function siapkanCarousel() {
    document.querySelectorAll('[data-fc-rec-viewport]').forEach(segarkanTitik);
  }
  document.addEventListener('DOMContentLoaded', siapkanCarousel);
  siapkanCarousel();

  /* ------------------------------------------------------------------
     Rekomendasi gear dari Search & Discovery.

     Liquid merender isi koleksi sebagai fallback, lalu daftar aslinya
     diambil dari endpoint rekomendasi: complementary products milik bibit
     pertama di keranjang, persis yang Nicole atur di app. Harga di endpoint
     ini berupa sen (integer), dan featured_image bisa null di level varian,
     jadi gambar dibaca dari level produk. */
  function uang(sen) {
    return '$' + (sen / 100).toFixed(2);
  }

  function amanTeks(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function kartuRekomendasi(p, labelAdd) {
    var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0];
    if (!v) return '';
    var img = '';
    if (p.featured_image) {
      var u = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=112';
      img = '<img src="' + amanTeks(u) + '" width="56" height="56" loading="lazy" alt="">';
    }
    return '<li class="fc-cart__rec">' +
      '<a class="fc-cart__rec-media" href="' + amanTeks(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="fc-cart__rec-text">' +
        '<a class="fc-cart__rec-title" href="' + amanTeks(p.url) + '">' + amanTeks(p.title) + '</a>' +
        '<p class="fc-cart__rec-price">' + uang(p.price) + '</p>' +
      '</div>' +
      '<button type="button" class="fc-cart__rec-add" data-fc-rec-add data-variant="' + v.id + '">' + labelAdd + '</button>' +
    '</li>';
  }

  function muatRekomendasi() {
    var vp = document.querySelector('[data-fc-rec-complementary]');
    if (!vp) return;
    /* Penanda anti-ulang: swap di bawah memutasi isi laci, dan observer di
       bawah menyalakan fungsi ini lagi pada tiap mutasi. Tanpa penanda ini
       jadinya fetch tanpa henti. Viewport hasil render ulang datang polos
       tanpa penanda, jadi daftar segar tetap dimuat. */
    if (vp.hasAttribute('data-fc-rec-loaded')) return;
    vp.setAttribute('data-fc-rec-loaded', '1');
    var pid = vp.getAttribute('data-fc-rec-complementary');
    var per = parseInt(vp.getAttribute('data-fc-rec-limit'), 10) || 3;
    if (!pid) return;

    /* Teks tombol diambil dari fallback yang sudah dirender Liquid, supaya
       terjemahannya tidak ditulis dua kali. */
    var tombolLama = vp.querySelector('[data-fc-rec-add]');
    var labelAdd = tombolLama ? tombolLama.textContent.trim() : 'Add';

    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=complementary')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var produk = (data && data.products || []).filter(function (p) { return p.available !== false; });
        if (!produk.length) return;

        /* render() bisa saja mengganti isi laci selagi menunggu jawaban. */
        if (!document.contains(vp)) {
          vp = document.querySelector('[data-fc-rec-complementary="' + pid + '"]');
          if (!vp) return;
        }

        /* Tanpa baris navigasi tidak ada titik ataupun panah, jadi halaman
           kedua dan seterusnya tidak akan pernah terjangkau. Batasi satu. */
        var nav = vp.parentElement.querySelector('.fc-cart__rec-nav');
        var maksHalaman = nav ? 4 : 1;
        var halaman = Math.min(maksHalaman, Math.ceil(produk.length / per));
        produk = produk.slice(0, halaman * per);

        var html = '';
        for (var h = 0; h < halaman; h++) {
          html += '<ul class="fc-cart__recs">' +
            produk.slice(h * per, h * per + per).map(function (p) { return kartuRekomendasi(p, labelAdd); }).join('') +
          '</ul>';
        }
        vp.innerHTML = html;
        vp.scrollLeft = 0;

        if (nav) {
          /* Jumlah titik disamakan dengan jumlah halaman hasil fetch. */
          var wadah = nav.querySelector('[data-fc-rec-dots]');
          var titik = wadah ? wadah.querySelectorAll('[data-fc-rec-dot]') : [];
          if (wadah && titik.length) {
            while (titik.length < halaman) {
              var klon = titik[0].cloneNode(true);
              klon.setAttribute('data-fc-rec-dot', String(titik.length));
              klon.classList.remove('is-active');
              wadah.appendChild(klon);
              titik = wadah.querySelectorAll('[data-fc-rec-dot]');
            }
            while (titik.length > halaman) {
              wadah.removeChild(titik[titik.length - 1]);
              titik = wadah.querySelectorAll('[data-fc-rec-dot]');
            }
          }
          nav.hidden = halaman <= 1;
        }
        segarkanTitik(vp);
      })
      .catch(function () { /* fallback koleksi tetap tampil */ });
  }
  document.addEventListener('DOMContentLoaded', muatRekomendasi);
  muatRekomendasi();

  /* ------------------------------------------------------------------
     Popup langganan (varian A dari mockup yang disetujui).

     Isi popup hidup di payload tersembunyi per baris (fc-cart-upsell).
     Saat dibuka, node-nya DIPINDAH ke shell, bukan disalin, supaya id
     select tidak ganda dan handler delegasi lama tetap kerja. Saat
     ditutup dikembalikan ke asalnya. Setelah Subscribe sukses, render()
     mengganti seluruh isi laci, jadi popup ikut lenyap dengan sendirinya. */
  function veilEl() {
    var d = drawer();
    return d && d.querySelector('[data-fc-veil]');
  }

  function tutupPopup() {
    var v = veilEl();
    if (!v || !v.classList.contains('is-open')) return;
    var slot = v.querySelector('[data-fc-popup-slot]');
    var kunci = slot.getAttribute('data-fc-popup-for');
    var isi = slot.firstElementChild;
    var asal = kunci && drawer().querySelector('[data-fc-popup-data="' + kunci + '"]');
    if (isi && asal) asal.appendChild(isi);
    slot.removeAttribute('data-fc-popup-for');
    v.classList.remove('is-open');
    var pemicu = kunci && drawer().querySelector('[data-fc-popup-open="' + kunci + '"]');
    if (pemicu) pemicu.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var buka = e.target.closest && e.target.closest('[data-fc-popup-open]');
    if (buka) {
      e.preventDefault();
      var kunci = buka.getAttribute('data-fc-popup-open');
      var v = veilEl();
      var data = drawer().querySelector('[data-fc-popup-data="' + kunci + '"]');
      if (!v || !data || !data.firstElementChild) return;
      var slot = v.querySelector('[data-fc-popup-slot]');
      tutupPopup();
      slot.appendChild(data.firstElementChild);
      slot.setAttribute('data-fc-popup-for', kunci);
      v.classList.add('is-open');
      /* Fokus ditunda satu frame: di tick yang sama, veil masih dalam
         transisi visibility dan focus() bisa gagal diam-diam. */
      requestAnimationFrame(function () {
        var sel = slot.querySelector('[data-fc-freq]');
        if (sel) sel.focus({ preventScroll: true });
      });
      return;
    }

    if (e.target.closest && e.target.closest('[data-fc-popup-close]')) {
      e.preventDefault();
      tutupPopup();
      return;
    }

    /* Klik latar gelap di luar kartu popup ikut menutup. */
    var v2 = veilEl();
    if (v2 && e.target === v2) tutupPopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') tutupPopup();
  });

  /* ------------------------------------------------------------------
     Dropdown frekuensi custom.

     Daftar terbuka milik <select> digambar oleh OS dan tidak bisa
     di-CSS, dan tampilannya bertabrakan dengan desain (keluhan Calvin,
     8 Sep). Select aslinya TETAP di DOM sebagai sumber data: pilihan
     dari daftar custom ditulis balik ke select lalu event change
     ditembakkan, jadi preview harga di popup dan perubahan frekuensi
     live di baris langganan memakai handler lama tanpa diubah.

     Hanya aktif di pointer halus. Di layar sentuh picker native iOS
     dan Android justru pengalaman yang benar, jadi dibiarkan. */
  var POINTER_HALUS = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)');

  function labelTerpilih(sel) {
    var o = sel.options[sel.selectedIndex];
    return o ? o.textContent.trim() : '';
  }

  function tutupSemuaDropdown(kecuali) {
    document.querySelectorAll('.fc-freqdd.is-open').forEach(function (w) {
      if (w !== kecuali) {
        w.classList.remove('is-open');
        var b = w.querySelector('.fc-freqdd__trigger');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function tingkatkanDropdown() {
    if (!POINTER_HALUS || !POINTER_HALUS.matches) return;
    var d = drawer();
    if (!d) return;
    d.querySelectorAll('select.fc-cart__freq-select:not([data-fc-enhanced])').forEach(function (sel) {
      sel.setAttribute('data-fc-enhanced', '1');

      var wrap = document.createElement('div');
      wrap.className = 'fc-freqdd';
      sel.parentNode.insertBefore(wrap, sel);
      wrap.appendChild(sel);
      sel.setAttribute('tabindex', '-1');
      sel.setAttribute('aria-hidden', 'true');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fc-cart__freq-select fc-freqdd__trigger';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="fc-freqdd__label"></span>' +
        '<svg class="fc-freqdd__chev" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">' +
        '<path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.querySelector('.fc-freqdd__label').textContent = labelTerpilih(sel);

      var list = document.createElement('ul');
      list.className = 'fc-freqdd__list';
      list.setAttribute('role', 'listbox');
      Array.prototype.forEach.call(sel.options, function (o, i) {
        var li = document.createElement('li');
        var ob = document.createElement('button');
        ob.type = 'button';
        ob.className = 'fc-freqdd__opt';
        ob.setAttribute('role', 'option');
        ob.setAttribute('data-i', String(i));
        ob.setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false');
        ob.textContent = o.textContent.trim();
        li.appendChild(ob);
        list.appendChild(li);
      });

      wrap.appendChild(btn);
      wrap.appendChild(list);

      function buka() {
        tutupSemuaDropdown(wrap);
        wrap.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        var aktif = list.querySelector('[aria-selected="true"]') || list.querySelector('.fc-freqdd__opt');
        if (aktif) aktif.focus({ preventScroll: true });
      }

      function tutup(fokusKeTombol) {
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        if (fokusKeTombol) btn.focus({ preventScroll: true });
      }

      function pilih(i) {
        if (sel.selectedIndex !== i) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        btn.querySelector('.fc-freqdd__label').textContent = labelTerpilih(sel);
        list.querySelectorAll('.fc-freqdd__opt').forEach(function (b, j) {
          b.setAttribute('aria-selected', j === i ? 'true' : 'false');
        });
        tutup(true);
      }

      btn.addEventListener('click', function () {
        wrap.classList.contains('is-open') ? tutup(false) : buka();
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); buka(); }
      });

      list.addEventListener('click', function (e) {
        var ob = e.target.closest('.fc-freqdd__opt');
        if (ob) pilih(+ob.getAttribute('data-i'));
      });
      list.addEventListener('keydown', function (e) {
        var semua = [].slice.call(list.querySelectorAll('.fc-freqdd__opt'));
        var pos = semua.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (semua[pos + 1] || semua[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (semua[pos - 1] || semua[semua.length - 1]).focus(); }
        else if (e.key === 'Home') { e.preventDefault(); semua[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); semua[semua.length - 1].focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); tutup(true); }
        else if (e.key === 'Tab') { tutup(false); }
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.fc-freqdd')) tutupSemuaDropdown(null);
  });

  document.addEventListener('DOMContentLoaded', tingkatkanDropdown);
  tingkatkanDropdown();

  /* Kuantitas dan tombol hapus ditangani JS theme, yang merender ulang laci
     lewat jalurnya sendiri tanpa menyentuh render() di atas. Observer ini
     menangkap SEMUA render ulang, siapa pun pelakunya, lalu memuat ulang
     rekomendasi. Penanda data-fc-rec-loaded di atas yang mencegahnya
     berputar memakan mutasinya sendiri. */
  (function () {
    var tunda = null;
    function pasangObserver() {
      var d = drawer();
      if (!d) return;
      new MutationObserver(function () {
        clearTimeout(tunda);
        tunda = setTimeout(function () {
          siapkanCarousel();
          muatRekomendasi();
          tingkatkanDropdown();
        }, 120);
      }).observe(d, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pasangObserver);
    } else {
      pasangObserver();
    }
  })();

  /* Tombol "Add" di section rekomendasi. Menambah varian ke keranjang lalu
     merender ulang laci, sehingga daftar rekomendasinya ikut berbalik kalau
     isi keranjang berubah jenis. */
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-fc-rec-add]');
    if (!add) return;
    e.preventDefault();

    sibuk(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: add.getAttribute('data-variant'), quantity: 1 }] })
    })
      .then(render)
      .then(function () { sibuk(false); })
      .catch(function () { sibuk(false); });
  });

  /* Tombol "Switch to a subscription".
     Frekuensinya diambil dari select di dalam blok upsell yang sama. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fc-subscribe]');
    if (!btn) return;
    e.preventDefault();

    var blok = btn.closest('[data-fc-upsell]');
    var sel = blok && blok.querySelector('[data-fc-freq]');
    if (!sel) return;

    ubahBaris(btn.getAttribute('data-line'), sel.value);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-fc-freq]');
    if (!sel) return;

    var opt = sel.options[sel.selectedIndex];

    /* Select di dalam blok upsell belum mengubah keranjang. Baris itu masih
       sekali beli, jadi yang diperbarui cuma harga yang ditampilkan sampai
       tombolnya ditekan. */
    if (sel.closest('[data-fc-upsell]')) {
      var blok = sel.closest('[data-fc-upsell]');
      var now = blok.querySelector('[data-fc-upsell-now]');
      var was = blok.querySelector('[data-fc-upsell-was]');
      if (now && opt) now.textContent = opt.getAttribute('data-price');
      if (was && opt) was.textContent = opt.getAttribute('data-was');
      return;
    }

    /* Select di kartu baris yang SUDAH berlangganan mengubah keranjang
       langsung, tanpa tombol tambahan. */
    ubahBaris(sel.getAttribute('data-line'), sel.value);
  });
})();
